/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  deleteDialogTitle: {
    id: "b2b.prilohy.delete-dialog.title",
    defaultMessage: "Delete attachment"
  },
  deleteDialogConfrimMesage: {
    id: "b2b.prilohy.delete-dialog.confrimMessage",
    defaultMessage: "Are you sure you want to delete the attachment {name}?"
  }
});

export default () => useMessages(MESSAGES);
